import delta from "./utils/delta.mjs";
import c from "./utils/console.mjs";
import { EVENT_FIRST_INTERACTION, EVENT_REPLAY_CAPTURED_EVENTS } from "@aguidrevitch/fpo-inpage-events";

const EVENT_CLICK = "click";

const w = window;
const wOrigAddEventListener = w.addEventListener.bind(w);
const wOrigRemoveEventListener = w.removeEventListener.bind(w);
const ra = "removeAttribute";
const ga = "getAttribute";
const sa = "setAttribute";
const passiveEvents = ["touchstart", "touchmove", "touchend", "touchcancel", "keydown", "wheel"]; //, "scroll"];
const activeEvents = ["mouseover", "mouseout", EVENT_CLICK];
const captureEvents = ["touchstart", "touchend", "touchcancel", "mouseover", "mouseout", EVENT_CLICK];
const prefix = "data-wpmeteor-";
const separator = "----";
const dispatchEvent = "dispatchEvent";

const synteticCick = e => {
    process.env.DEBUG && c(delta(), "creating syntetic click event for", e);
    const event = new MouseEvent(EVENT_CLICK, {
        view: e.view,
        bubbles: true,
        cancelable: true
    });
    Object.defineProperty(event, "target", { writable: false, value: e.target });
    return event;
};

class InteractionEvents {
    static capture() {
        let firstInteractionFired = false;

        // lighthouse sets __nativePromise and __nativeURL
        // to the original Promise and URL
        const [, p, n] = `${window.Promise}`.split(/[\s[(){]+/s);
        if (w["__" + n + p]) {
            return;
        }

        const capturedEvents = [];
        const captureEvent = e => {
            if (e.target && (dispatchEvent in e.target)) {
                if (!e.isTrusted) {
                    // this is a flag that this event is probably replaying
                    process.env.DEBUG && c(delta(), "the event is not trusted, configuration issues, not recording", e.type, e.target);
                    process.env.DEBUG && c(delta(), "please double check if first interaction listener was installed before wp-meteor");
                    return;
                }
                if (e.cancelable && !passiveEvents.includes(e.type)) {
                    try {
                        e.preventDefault();
                    } catch { }
                }
                e.stopImmediatePropagation();

                if (e.type === EVENT_CLICK) {
                    process.env.DEBUG && c(delta(), "captured", e.type, e.target);
                    capturedEvents.push(synteticCick(e));
                } else if (captureEvents.includes(e.type)) {
                    process.env.DEBUG && c(delta(), "captured", e.type, e.target);
                    capturedEvents.push(e);
                }
                // scroll event target doesn't have setAttribute
                // if (e.target[sa]) {
                //     e.target[sa](prefix + e.type, true);
                // }
                e.target[sa](prefix + e.type, true);
                if (!firstInteractionFired) {
                    firstInteractionFired = true;
                    w[dispatchEvent](new CustomEvent(EVENT_FIRST_INTERACTION));
                }
            }
        };

        w.addEventListener(EVENT_REPLAY_CAPTURED_EVENTS, () => {
            process.env.DEBUG && c(delta(), separator, "got " + EVENT_REPLAY_CAPTURED_EVENTS);
            process.env.DEBUG && c(delta(), separator, "removing event listeners");
            activeEvents.forEach(event => wOrigRemoveEventListener(event, captureEvent, { passive: false, capture: true }));
            passiveEvents.forEach(event => wOrigRemoveEventListener(event, captureEvent, { passive: true, capture: true }));

            let e;
            while (e = capturedEvents.shift()) { // eslint-disable-line no-cond-assign
                var target = e.target;
                if (target[ga](prefix + "touchstart") && target[ga](prefix + "touchend") && !target[ga](prefix + EVENT_CLICK)) {
                    if (target[ga](prefix + "touchmove")) {
                        process.env.DEBUG && c(delta(), `touchmove happened, so not dispatching ${EVENT_CLICK} to `, e.target);
                    } else {
                        // why would I want to remove prefix + "touchmove", if previous if checks it is present?
                        // target[ra](prefix + "touchmove");
                        capturedEvents.push(synteticCick(e));
                    }
                    target[ra](prefix + "touchstart");
                    target[ra](prefix + "touchend");
                } else {
                    target[ra](prefix + e.type);
                }
                process.env.DEBUG && c(delta(), " dispatching " + e.type + " to ", e.target);
                target[dispatchEvent](e);
            }
        });

        process.env.DEBUG && c(delta(), separator, "installing first interaction event listeners");
        activeEvents.forEach(event => wOrigAddEventListener(event, captureEvent, { passive: false, capture: true }));
        passiveEvents.forEach(event => wOrigAddEventListener(event, captureEvent, { passive: true, capture: true }));
    }
}

export {
    InteractionEvents,
};

export default InteractionEvents;